// extracted by mini-css-extract-plugin
export default {"body":"StudentProfile_body__UG0Vr","stats":"StudentProfile_stats__bgAAr","optsCont":"StudentProfile_optsCont__DsqW8","danger":"StudentProfile_danger__mXlPO"};